MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');

  MS.productlanding_benefit = {
    selectors: {
      benefitcontainer: $('.ms-pl-benefit'),
      benefitItems: $('.ms-pl-benefit__item')
    },

    init: function() {
      this.animateOnPositionCheck();
    },

    // animate the first benefit item immediately if it is place below the hero
    // prevent an empty spot at the bottom when page loads
    animateOnPositionCheck: function() {
      var $productHero = $('.ms-pl-hero');

      if ($productHero.next().hasClass('ms-pl-benefit')) {
        this.selectors.benefitItems.first().addClass('ms-animated');
      }

    }

  }

  })(jQuery);
